export default __webpack_public_path__ + "static/media/blaspheme.ce0fe9d6.png";